import React, { useEffect, useState } from 'react'
import * as image from "../../resources/images";
import { getSequnceSort, getUrlSegment } from '../../utils/helper';
import { getDimensions, getMyPlan, logoutAction } from '../../redux/actions/APIs';
import { defaultChild, resetResponse, resetStripePlans, showModal } from '../../redux/actions';
import { getDashboard } from '../../redux/actions/Home';
import { useDispatch, useSelector } from 'react-redux';
import { PATHS } from '../../utils';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

const SidebarNew = ({ collaspe, handleeclick }) => {

    const history = useHistory();
    const dispatch = useDispatch();
    const pageType = getUrlSegment()[0];


    const { loggedInUser, defaultChildData, alluserdetails, getMyPlanData, getdimension } = useSelector(
        (state) => state.collections
    );

    useEffect(() => {
        if (!getdimension) {
            dispatch(getDimensions(defaultChildData?.id));
        }
    }, [defaultChildData]);

    const homeRedirect = (obj) => {
        if (getUrlSegment()[0] === "home") {
            return;
        }
        dispatch(getMyPlan())
        dispatch(getDashboard());
        dispatch(defaultChild(defaultChildData));
        dispatch(getDashboard(defaultChildData?.id));
        dispatch(resetResponse());
        history.push({
            pathname: PATHS.HOME,
        });
    };

    const coursePageRedirect = () => {

        history.push(PATHS.COURSE_CATLOG_STR + defaultChildData?.id);

    };

    const handleMyPlan = () => {
        if (getUrlSegment()[0] !== "myplan") {
            if (defaultChildData?.isUserPlan ) {
                dispatch(getMyPlan())
                history.push({
                    pathname: PATHS.MYPLAN_PAGE,
                })
            } else {
                if(getUrlSegment()[0] !== "userplan"){
                    dispatch(showModal({ type: "MyLearnerPlanRedirectPopup" }));
                }
                
            }
        }
    }

    const dimensionRedirect = () => {
        let dimensions = getSequnceSort(getdimension?.records);
        history.push(PATHS.DIMENSION_STR + dimensions[0]?.id + "/" + defaultChildData?.id);

    }

    const handlePopUp = () => {
        dispatch(resetStripePlans());
        dispatch(showModal({ type: "Subscription" }));
    };

    const helpRedirect = () => {
        dispatch(showModal());
        history.push(PATHS.HELP);
    }



    return (
        <div className='NwSidebar '>
            {getUrlSegment()[0] === "user-profile" ? (
                <div className='newsidebarlist w-100'>
                    <ul>
                        <li className='logoicon_items'>
                            <div className='sidebaritems'>
                                <img src={image.greenflag} className='logoicon' alt='bloomster icon' />
                                <img src={image.vicky_logo_LP} className='colorlogo'></img>
                                <span className='sidebarcollaspeicon br-50 flexfive'><i class="fa-regular fa-chevron-right"></i></span>

                            </div>
                        </li>
                    </ul>
                    <ul>
                        <li className='flexone px-2' onClick={() => dispatch(logoutAction(alluserdetails))}>
                            <div className='sidebaritems flextwo pointer'>
                                <span><img src={image.logout_white} alt='home' className='notactive' /></span>
                                <span className='sidebattxt'>Logout</span>
                            </div>
                        </li>

                    </ul>
                </div>
            ) : (
                <div className='newsidebarlist w-100'>
                    <ul>
                        <li className=' flexone logoicon_items'>
                            <div className='sidebaritems'>
                                <img src={image.greenflag} className='logoicon' alt='bloomster icon' />
                                <img src={image.vicky_logo_LP} className='colorlogo'></img>
                                <span className='sidebarcollaspeicon br-50 flexfive pointer' onClick={() => handleeclick()}>
                                    <i class="fa-regular fa-chevron-left"></i>
                                </span>
                                {/* {
                                    collaspe ? (
                                        <span className='sidebarcollaspeicon br-50 flexfive pointer' onClick={() => handleeclick()}>
                                            <i class="fa-regular fa-chevron-left"></i>
                                        </span>
                                    ) : (
                                        <span className='sidebarcollaspeicon br-50 flexfive pointer' onClick={() => handleeclick()}>
                                            <i class="fa-regular fa-chevron-right"></i>
                                        </span>
                                    )
                                } */}
                            </div>
                        </li>
                        <li className='flexone px-2'>
                            <div className={`sidebaritems flextwo ${pageType === "home" && "Active_navitems"} pointer`} onClick={() => homeRedirect()}>
                                <span><img src={image.nav_grid} alt='home' className='notactive' /></span>
                                <span><img src={image.grid_white} alt='home' className='activenav' /></span>
                                <span className='sidebattxt'>Home</span>
                            </div>
                        </li>
                        <li className='flexone px-2'>
                            <div className={`sidebaritems flextwo ${pageType === "course-catalog" && "Active_navitems"} pointer`} onClick={() => coursePageRedirect()}>
                                <span><img src={image.nav_Course} alt='course' className='notactive' /></span>
                                <span><img src={image.course_white} alt='course' className='activenav' /></span>
                                <span className='sidebattxt'>Course Catalog</span>
                            </div>
                        </li>
                        <li className='flexone px-2'>
                            <div className={`sidebaritems flextwo ${(pageType === "userplan" || pageType === "course-details") && "Active_navitems"} pointer`} onClick={() => handleMyPlan()}>
                                <span><img src={image.nav_Paln} alt='paln' className='notactive' /></span>
                                <span ><img src={image.plan_white} alt='plan' className='activenav' /></span>

                                <span className='sidebattxt'>My Plans</span>
                            </div>
                        </li>
                        {/* <li className='px-2'>
                            <div className='sidebaritems flextwo pointer' onClick={() => dimensionRedirect()}>
                                <span><img src={image.nav_Dimension} alt='dimension' className='notactive' /></span>
                                <span><img src={image.dimension_white} alt='dimension' className='activenav' /></span>

                                <span className='sidebattxt'>Dimensions</span>
                            </div>
                        </li> */}
                    </ul>
                    <ul>
                        {loggedInUser?.role?.name === "PARENT" && (
                            <li className='flexone px-2'>
                            <div className='sidebaritems flextwo pointer' onClick={() => handlePopUp()}>
                                <span><img src={image.Subscribe_} alt='home' className='notactive' /></span>
                                <span className='sidebattxt'>Subscribe</span>
                            </div>
                        </li>
                        )}

                        {/* <li className='px-2'>
                            <div className='sidebaritems flextwo pointer' onClick={() => helpRedirect()}>
                                <span><img src={image.Help_white} alt='home' className='notactive' /></span>
                                <span className='sidebattxt'>Help Center</span>
                            </div>
                        </li> */}

                        <li className='flexone px-2' onClick={() => dispatch(logoutAction(alluserdetails))}>
                            <div className='sidebaritems flextwo pointer'>
                                <span><img src={image.logout_white} alt='home' className='notactive' /></span>
                                <span className='sidebattxt'>Log Out</span>
                            </div>
                        </li>

                    </ul>
                </div>
            )
            }

        </div>
    )
}

export default SidebarNew
